import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled.fieldset`
  display: grid;
  grid-template:
    "title" auto
    "fields" auto / 1fr;
  row-gap: ${rem(20)};

  ${mediaQueryUp.tablet} {
    column-gap: ${rem(16)};
    grid-template:
      "step title" auto
      ". fields" auto / ${rem(24)} 1fr;
  }
`

const Step = styled(Heading)`
  grid-area: step;
  display: none;

  ${mediaQueryUp.tablet} {
    display: block;
    place-self: center;
  }
`

const Title = styled(Heading)`
  grid-area: title;
`

const Fields = styled.div`
  grid-area: fields;
`

interface Props extends PropsWithChildren {
  step: number
  title: string
}

function TailorMadeTourFormFieldset({ children, step, title }: Props) {
  return <Container>
    <Step variant="heading4" align="center">{step}.</Step>
    <Title variant="heading4">{title}</Title>
    <Fields>{children}</Fields>
  </Container>
}

export default TailorMadeTourFormFieldset
